import {
  AuthIdTokenParsed,
  AuthOptions,
  createAuthClient,
  generateOnBehalfOfScope
} from '@storebrand-digital/auth';
import { readAdvisorSession } from '../advisor';
import { isAdvisorMode } from '../environment';

const allowedACRs = {
  al1: 'https://id.storebrand.no/authn/al1',
  al2: 'https://id.storebrand.no/authn/al2',
  al3: 'https://id.storebrand.no/authn/al3',
  al4: 'https://id.storebrand.no/authn/al4'
} as const;

const customerOptions: AuthOptions = {
  config: {
    clientId: window.env.KEYCLOAK_CLIENT,
    realm: window.env.KEYCLOAK_REALM,
    url: window.env.KEYCLOAK_URL
  },
  init: {
    scope: window.env.KEYCLOAK_SCOPES
  },
  login: {
    scope: window.env.KEYCLOAK_SCOPES,
    allowedACR: [allowedACRs.al3, allowedACRs.al4]
  },
  logout: {
    redirectUri: window.env.KEYCLOAK_LOGOUT_URL
  },
  autoRefresh: true
};

const session = readAdvisorSession();

const advisorOptions: AuthOptions = {
  config: {
    clientId: window.env.KEYCLOAK_CLIENT,
    realm: window.env.KEYCLOAK_REALM_ADVISOR,
    url: window.env.KEYCLOAK_URL_ADVISOR
  },
  init: {
    scope: [
      window.env.KEYCLOAK_SCOPES_ADVISOR,
      generateOnBehalfOfScope(session.cmId)
    ].join(' ')
  },
  login: {
    scope: [
      window.env.KEYCLOAK_SCOPES_ADVISOR,
      generateOnBehalfOfScope(session.cmId)
    ].join(' '),
    allowedACR: [allowedACRs.al3, allowedACRs.al4]
  },
  logout: {
    redirectUri: window.env.KEYCLOAK_LOGOUT_URL
  },
  autoRefresh: true
};

const auth = createAuthClient(isAdvisorMode ? advisorOptions : customerOptions);

export default auth;

export function getIdTokenParsed(): AuthIdTokenParsed | undefined {
  return auth.authenticated ? auth.idTokenParsed : undefined;
}

export function isAdvisor() {
  return auth.advisor.iss?.includes('auth/realms/corporate') ?? false;
}

/**
 * A numeric value indicating authorization level.
 */
type ACRLevel = 0 | 1 | 2 | 3 | 4;

export function hasAcr(level: ACRLevel) {
  const idToken = getIdTokenParsed();
  const acr = idToken?.acr ?? '';
  return parseInt(acr.split('/authn/al')[1], 10) >= level;
}
